import { render, staticRenderFns } from "./CartDeclaration.vue?vue&type=template&id=63b9469e&scoped=true"
import script from "./CartDeclaration.vue?vue&type=script&lang=js"
export * from "./CartDeclaration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9469e",
  null
  
)

export default component.exports